import {fromJS} from 'immutable';

import {UPDATE_TEXTAREA_FOCUS} from './actions';

export const initialState = fromJS({
  status: {
    hasTextAreaFocus: false
  }
});

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_TEXTAREA_FOCUS:
      return state.setIn(['status', 'hasTextAreaFocus'], action.payload.state);
    default:
      return state;
  }
}
